module.exports = __webpack_public_path__ + "img/yishi4.6bbc8cd2.jpg";